import React from "react"
import { LogoWrapper, LogoImage } from "../../UIKit/styles"
import zespri_logo from "../../assets/images/zespri_logo.png"

export default function Header() {
  return (
    <LogoWrapper>
      <LogoImage src={zespri_logo} alt="Zespri Orchard emissions calculator" />
    </LogoWrapper>
  )
}
